import React, { createContext, useEffect } from "react";
import { Row } from "react-bootstrap";
import { useForm } from "react-hook-form";

export const Context = createContext({});

const Form = ({ defaultValues, children, onSubmit }) => {
    const {
        handleSubmit,
        setValue,
        getValues,
        register,
        control,
        watch,
        formState: { errors },
        reset,
    } = useForm({
        defaultValues,
    });

    useEffect(() => {
        if (defaultValues) {
            reset(defaultValues || {});
        }
    }, [defaultValues]);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
                <Context.Provider
                    value={{
                        register,
                        errors,
                        control,
                        values: defaultValues,
                        setValue,
                        getValues,
                        watch,
                    }}
                >
                    {children}
                </Context.Provider>
            </Row>
        </form>
    );
};
export default Form;
